import React, { useEffect } from "react";
import Button from "@material-ui/core/Button";
import GetAppIcon from "@material-ui/icons/GetApp";
import OrderTracker from "../OrderTracker/OrderTracker";
import Switch from "../Switch/Switch";
import axios from "../../utils/Axios/axiosProxy";
import { withTranslation } from "react-i18next";
import i18n from "../../utils/LanguageSelector/i18n";
import "./OrderStatus.scss";

function OrderStatus({ content }) {
  const [notifications, setNotifications] = React.useState(false);

  useEffect(() => {
    setNotifications(content.notifications);
  }, [content.notifications]);

  const Payment = {
    open: i18n.t("general.open"),
    overdue: i18n.t("general.overdue"),
    paid: i18n.t("general.paid"),
  };

  const documentLabels = {
    freightbill: i18n.t("general.freightbill"),
    invoice: i18n.t("general.invoice"),
  };
  const getPDF = (filename) => {
    axios
      .get(`/pdf/${filename}.pdf`, {
        headers: {
          "Content-Type": "application/pdf",
        },
      })
      .then((response) => {
        window.open(response.data.url, "_blank");
        console.log("GET PDF RESPONSE: ", response);
      })
      .catch((error) => {
        console.log("GET PDF ERROR: ", error);
      })
      .catch((error) => console.log("GET PDF CLIENT ERROR", error));
  };

  const updateOrderNotification = (checked) => {
    let data = {
      orderID: content._id,
      updateParams: { notifications: checked },
    };
    axios
      .patch("/api/order/update", data, {
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("UPDATE ORDER RESPONSE: ", response.statusText);
      })
      .catch((error) => {
        console.log("UPDATE ORDER ERROR: ", error.response.data);
      })
      .catch((error) => console.log("submitToDB error", error));
  };

  const HeadingItems = [
    { label: i18n.t("general.ordernr"), value: content._id },
    { label: i18n.t("matable.date"), value: content.datecreated },
    {
      label: i18n.t("general.shipper"),
      value:
        content.shipperaddresses[0].companyname !== undefined
          ? content.shipperaddresses[0].companyname
          : `${content.contact.firstname} ${content.contact.lastname}`,
    },
    {
      label: i18n.t("general.consignee"),
      value:
        content.consigneeaddresses[0].companyname !== undefined
          ? content.consigneeaddresses[0].companyname
          : ``,
    },
    { label: i18n.t("matable.payment"), value: Payment[content.payment] },
  ];

  const displayDocuments = (orderDocuments) => {
    let documents = [];
    for (let i in orderDocuments) {
      documents.push(
        <Button
          className="ToreaBay Medium MarginHorizontal MarginSides"
          variant="contained"
          onClick={() => {
            getPDF(orderDocuments[i]);
          }}
        >
          <span style={{ display: "inline-flex", alignItems: "center" }}>
            <GetAppIcon />
          </span>
          {`${documentLabels[i] ? documentLabels[i] : i}`}
        </Button>
      );
    }
    return documents;
  };

  return (
    <>
      <div className="OrderContainer">
        <div className="OrderHeading">
          {HeadingItems.map((item) => {
            return (
              <div className="HeadingItems" key={item.label}>
                <li className="WhiteItalic">{item.label}</li>
                <li className="Bold" id={item.id}>
                  {item.value}
                </li>
              </div>
            );
          })}
        </div>
        <div className="OrderTracker">
          <OrderTracker details order={content} />
          <div className="NotificationSwitch BottomBorder">
            <Switch
              checked={notifications}
              word1="On"
              word2="Off"
              labelFront="Notifications"
              onChange={(event) => {
                setNotifications(event.target.checked);
                updateOrderNotification(event.target.checked);
              }}
            />
          </div>
          <div className="DocumentsContainer BottomBorder">
            <p className="OrangeFont Bold">{i18n.t("general.documents")}</p>
            {content.documents ? (
              displayDocuments(content.documents)
            ) : (
              <>
                <div className="FlexCenter" style={{ minHeight: "150px" }}>
                  <p className="Bold Padding8">
                    {i18n.t("general.nodocuments")}
                  </p>
                </div>
              </>
            )}
            {/*             
            <Button className="ToreaBay Small MarginSides">Invoice</Button> */}
          </div>
          {content.notes !== undefined && content.notes.length > 0 ? (
            <div className="OrderNotes">
              <p className="OrangeFont Bold">{i18n.t("dashboard.notes")}</p>
              <p className="Italic">{content.notes}</p>
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
}

export default withTranslation()(OrderStatus);
